import axios from 'axios';
import qs from 'qs';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class CesService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getGeneralMetrics(fromDate, toDate) {
    try {
      const res = await axios.get(`${adminUrl}/ces/general`, {
        headers: this.getHeaders(),
        params: { fromDate, toDate },
      });
      return { status: 'ok', data: res.data };
    } catch (err) {
      console.error('[CES] getGeneralMetrics error:', err?.response?.data || err.message);
      return { status: 'error', data: { avgCES: null, totalResponses: 0 } };
    }
  }

  static async getB2BCompanies() {
    try {
      const res = await axios.get(`${adminUrl}/ces/companies`, {
        headers: this.getHeaders(),
      });
      return { status: 'ok', data: res.data };
    } catch (err) {
      console.error('[CES] getB2BCompanies error:', err?.response?.data || err.message);
      return { status: 'error', data: [] };
    }
  }

  static async getB2BCESOverTime(fromDate, toDate, companyIds) {
    try {
      const res = await axios.get(`${adminUrl}/ces/b2b`, {
        headers: this.getHeaders(),
        params: { fromDate, toDate, companyIds },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      });
      return { status: 'ok', data: res.data };
    } catch (err) {
      console.error('[CES] getB2BCESOverTime error:', err?.response?.data || err.message);
      return { status: 'error', data: [] };
    }
  }

  static async getB2CCESOverTime(fromDate, toDate) {
    try {
      const res = await axios.get(`${adminUrl}/ces/b2c`, {
        headers: this.getHeaders(),
        params: { fromDate, toDate },
      });
      return { status: 'ok', data: res.data };
    } catch (err) {
      console.error('[CES] getB2CCESOverTime error:', err?.response?.data || err.message);
      return { status: 'error', data: [] };
    }
  }

  static async getCESByCoverage(fromDate, toDate) {
    try {
      const res = await axios.get(`${adminUrl}/ces/by-coverage`, {
        headers: this.getHeaders(),
        params: { fromDate, toDate },
      });
      return { status: 'ok', data: res.data };
    } catch (err) {
      console.error('[CES] getCESByCoverage error:', err?.response?.data || err.message);
      return { status: 'error', data: [] };
    }
  }
}
